import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/LoginPage.vue'),
    meta: { title: 'Login', noAuth: true }
  },
  {
    path: '/no-permission',
    name: 'NoPermission',
    component: () => import('@/views/NoPermission.vue'),
    meta: { title: 'No Permission', noAuth: true }
  },
  {
    path: '/',
    component: () => import('@/components/Layout.vue'),
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/DashboardPage.vue'),
        meta: { title: 'Dashboard', icon: 'el-icon-s-home', permission: 'dashboard:view' }
      },
      {
        path: 'merchants',
        name: 'Merchants',
        component: () => import('@/views/merchants/MerchantList.vue'),
        meta: { title: 'Merchants', icon: 'el-icon-office-building', permission: 'merchant:view' }
      },
      {
        path: 'merchants/:merchantId',
        name: 'MerchantDetail',
        component: () => import('@/views/merchants/MerchantDetail.vue'),
        meta: { title: 'Merchant Detail', icon: 'el-icon-office-building', permission: 'merchant:view' }
      },
      {
        path: 'stores',
        name: 'Stores',
        component: () => import('@/views/stores/StoreList.vue'),
        meta: { title: 'Stores', icon: 'el-icon-s-shop', permission: 'store:view' }
      },
      {
        path: 'stores/:storeId',
        name: 'StoreDetail',
        component: () => import('@/views/stores/StoreDetail.vue'),
        meta: { title: 'Store Detail', icon: 'el-icon-shop', permission: 'store:view' }
      },
      {
        path: 'sa',
        name: 'SaList',
        component: () => import('@/views/sa/SaList.vue'),
        meta: { title: 'SA', icon: 'el-icon-user', permission: 'sa:view' }
      },
      {
        path: 'sa/:saId',
        name: 'SaDetail',
        component: () => import('@/views/sa/SaDetail.vue'),
        meta: { title: 'SA Detail', icon: 'el-icon-user', permission: 'sa:view' }
      },
      {
        path: 'import/preview',
        name: 'ImportPreview',
        component: () => import('@/views/import/ImportPreview.vue'),
        meta: { title: 'Import Preview', icon: 'el-icon-upload2', permission: 'import:view' }
      },
      {
        path: 'sku',
        name: 'SkuList',
        component: () => import('@/views/sku/SkuList.vue'),
        meta: { title: 'SKU', icon: 'el-icon-goods', permission: 'sku:view' }
      },
      {
        path: 'sku/:skuId',
        name: 'SkuDetail',
        component: () => import('@/views/sku/SkuDetail.vue'),
        meta: { title: 'SKU Detail', icon: 'el-icon-goods', permission: 'sku:view' }
      },
      {
        path: 'price-import',
        name: 'PriceImportList',
        component: () => import('@/views/price/PriceImportList.vue'),
        meta: { title: 'SKU Import', icon: 'el-icon-coin', permission: 'price_import:view' }
      },
      {
        path: 'price-import/:batchNo',
        name: 'PriceImportDetail',
        component: () => import('@/views/price/PriceImportDetail.vue'),
        meta: { title: 'SKU Import Detail', icon: 'el-icon-coin', permission: 'price_import:view' }
      },
      {
        path: 'price-log',
        name: 'PriceLog',
        component: () => import('@/views/price/PriceLog.vue'),
        meta: { title: 'SKU Change Log', icon: 'el-icon-document', permission: 'price_log:view' }
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('@/views/user/UserList.vue'),
        meta: { title: 'Users', icon: 'el-icon-s-custom', permission: 'user:view' }
      },
      {
        path: 'roles',
        name: 'Roles',
        component: () => import('@/views/role/RolePermission.vue'),
        meta: { title: 'Roles', icon: 'el-icon-s-operation', permission: 'role:manage' }
      }
    ]
  },
  {
    path: '*',
    redirect: '/dashboard'
  }
]

const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Avoided redundant navigation')) {
      return Promise.reject(err)
    }
  })
}
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Avoided redundant navigation')) {
      return Promise.reject(err)
    }
  })
}

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - Channel Center` : 'Channel Center'
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.token) {
      next({ path: '/login', query: { redirect: to.fullPath } })
      return
    }
    // 基于权限码的路由守卫：缺少所需权限则跳转到无权限页（避免重定向到 /dashboard 造成死循环）
    const requiredPermission = to.meta.permission
    if (requiredPermission && !store.getters.hasPermission(requiredPermission)) {
      if (to.path === '/no-permission') {
        next()
        return
      }
      next({ path: '/no-permission' })
      return
    }
    next()
  } else {
    next()
  }
})

export default router
